import { render, staticRenderFns } from "./menage.vue?vue&type=template&id=25f1d748&scoped=true"
import script from "./menage.vue?vue&type=script&lang=js"
export * from "./menage.vue?vue&type=script&lang=js"
import style0 from "./menage.vue?vue&type=style&index=0&id=25f1d748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1d748",
  null
  
)

export default component.exports